import { get } from 'lodash'

const development = {
  email: null,
  password: null
}

const credentials = {
  type: 'user',
  email: null,
  password: null,
  remember: null
}

/**
 * Production or Develop
 */
const getCredentials = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return {...credentials, ...development}
  }

  return {...credentials}
}
export default () => ({
  loginFail: '',
  errors: {},
  credentials: getCredentials()
})



// WEBPACK FOOTER //
// ./src/app/auth/login/dweller/resources/data.js